import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Empty from 'components/views/PoolView/render/custom/Empty';
import { getCoach } from 'store/profile';
import { RootStateType as ProfileRootStateType } from 'store/profile';
import { actionCreators as transientPoolStateAC } from 'store/transientPoolState';
import { RootStateType as TransientPoolStateType } from 'store/transientPoolState';

type RootStateType = ProfileRootStateType & TransientPoolStateType;

const mapStateToProps = (state: RootStateType, ownProps: any) => {
	return {
		coach: getCoach(state),
	};
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators(
		{
			doUnsetAllFilters: transientPoolStateAC.doUnsetAllFilters,
		},
		dispatch
	);
};

export default connect(mapStateToProps, mapDispatchToProps)(Empty as any);
